export default {
      id: "icon--wear-wooly-hat-gloves-usage",
      viewBox: "0 0 26.3 29.3",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wear-wooly-hat-gloves-usage",
      toString: function () {
        return this.url;
      }
    }